import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    backend:
      process.env.NODE_ENV == "production"
        ? "https://capital77.com.co:9010"
        : "http://localhost:9010"
  }
});
